/**
 * ClaudeDocs — shared layout primitives.
 *
 * Extracted verbatim from ../ClaudeDocs.tsx: the CodeBlock + Section layout
 * primitives. Static data + nav types live in ./data (kept separate so this
 * module only exports components). No styling/logic changes.
 */

import React from 'react';

export const CodeBlock: React.FC<{ children: string; lang?: string }> = ({ children, lang }) => (
  <pre className="text-xs bg-gray-900 text-gray-100 p-3 rounded-lg overflow-x-auto my-3 max-w-full">
    <code className="whitespace-pre">
      {lang && <span className="text-gray-500 select-none">{`# ${lang}\n`}</span>}
      {children}
    </code>
  </pre>
);

export const Section: React.FC<{ id: string; title: string; children: React.ReactNode }> = ({
  id,
  title,
  children,
}) => (
  <section id={id} className="scroll-mt-20 mb-12 min-w-0">
    <h2 className="text-2xl font-semibold text-gray-900 mb-3 break-words">{title}</h2>
    <div className="prose prose-sm max-w-none text-gray-700 leading-relaxed space-y-3 break-words [&_code]:break-all">
      {children}
    </div>
  </section>
);
